import { createReducer, on } from '@ngrx/store';
import * as actions from './se-side-nav.actions';
import { cloneDeep, merge } from 'lodash-es';
import { seSideNavComponentInitialState, SeSideNavComponentState } from './se-side-nav.state';
import { SeSideComponentType } from '../se-side-components/se-side-components-models';
import { DeepPartial } from '../../utils/types';

export const seSideNavReducer = createReducer(
    seSideNavComponentInitialState,
    on(actions.seSideNavComponentSetActiveComponents, (state, { activationList, customProps }) =>
        setActiveComponents(state, activationList, customProps)
    )
);

function setActiveComponents(
    state: SeSideNavComponentState,
    activationList: SeSideComponentType[],
    customProps?: DeepPartial<SeSideNavComponentState>
): SeSideNavComponentState {
    // Resetto tutti gli stati attivi
    let newState = cloneDeep(state);
    for (const key in newState) {
        newState[key].active = false;
    }

    // Imposto attivi quelli passati
    for (const key of activationList) {
        newState[key].active = true;
    }

    return customProps ? merge(newState, customProps): newState;
}
